import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormSelectorComponent } from './components/form-selector/form-selector.component';
import { HeaderResolver } from '@finra/rampdi-forms-common';
import { InstanceService } from './services/instance.service';
import { ModelService } from './services/model.service';
import { NavigationDataService } from './services/navigation-data.service';
import { SchemaService } from './services/schema.service';
import { FipSessionService } from '@finra/fip-session';
import { RouteNoopComponent } from './components/route-noop/route-noop.component';
import { ErrorRouteComponent } from './components/error-route/error-route.component';
import { PostSubmissionComponent } from './components/post-submission/post-submission.component';
import { AuthorizationGuard } from './guards/authorization.guard';
import { UpdateRecordGuard } from './guards/update-record.guard';

const routes: Routes = [
  {
    path: 'error',
    data: {
      hasRoutingError: true,
    },
    component: ErrorRouteComponent,
  },
  {
    path: 'updateRecord',
    canActivate: [UpdateRecordGuard],
    component: RouteNoopComponent,
  },
  {
    path: 'create',
    resolve: {
      createResolution: InstanceService,
    },
    data: {
      create: true,
    },
    component: RouteNoopComponent,
  },
  {
    path: '',
    resolve: {
      instanceData: InstanceService,
    },
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'view/dataEntry/section/identifyingInformation',
      },
      {
        path: 'view/:viewType',
        resolve: {
          schemas: SchemaService,
        },
        runGuardsAndResolvers: 'always',
        canActivate: [AuthorizationGuard],
        children: [
          {
            path: 'section/:sectionId',
            resolve: {
              navData: NavigationDataService,
              headerData: HeaderResolver,
              model: ModelService,
            },
            component: FormSelectorComponent,
            runGuardsAndResolvers: 'always',
            canActivate: [FipSessionService],
            data: {
              groups: [],
            },
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'section/identifyingInformation',
          },
        ],
      },
      {
        path: 'post-submission',
        component: PostSubmissionComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'view/dataEntry/section/identifyingInformation',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 10],
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
